import { type SyntheticEvent } from 'react';
import { useCallback, useState } from 'react';
import * as React from 'react';
import { Popover } from 'react-tiny-popover';
import styled, { css } from 'styled-components';

import { ReactComponent as HexLogo } from '../../../images/hex-logo.svg';
import { ReactComponent as ArrowRight } from '../../../images/icons/icon-arrow-right.svg';
import { MEDIA_KIT_LINK } from '../../../utils';
import { Menu, MenuItem } from '../../design-system';
import { LinkWithQuery } from '../LinkWithQuery';

const Logo = styled.div<{ $large: boolean }>`
  display: flex;
  align-items: center;
  height: 30px;

  svg {
    height: 20px;
    width: 52px;
  }

  ${({ $large }) =>
    $large &&
    css`
      height: auto;

      svg {
        height: 22px;
        width: auto;
      }
    `}

  a {
    display: flex;
    text-decoration: none;
    border: none;

    &:hover {
      background: none;
    }

    svg {
      color: ${({ theme }) => theme.highlightColor};
    }
  }
`;

interface NavLogoProps {
  isMobile?: boolean;
  large?: boolean;
}

export const NavLogo: React.ComponentType<NavLogoProps> = React.memo(
  ({ isMobile = false, large = false }) => {
    const [isPopoverOpen, setPopoverOpen] = useState<boolean>(false);

    const _toggleLogoPopover = useCallback(() => {
      setPopoverOpen(prev => !prev);
    }, []);

    const _handleRightClick = useCallback(
      (e: SyntheticEvent) => {
        if (e.type === 'contextmenu') {
          e.preventDefault();
          _toggleLogoPopover();
        }
      },
      [_toggleLogoPopover]
    );

    return (
      <>
        {!isMobile ? (
          <Popover
            align="start"
            containerStyle={{ zIndex: '999999' }}
            content={
              <Menu>
                <MenuItem
                  text={
                    <>
                      <span
                        style={{
                          marginRight: '10px'
                        }}>
                        View Media kit
                      </span>
                      <ArrowRight />
                    </>
                  }
                  onClick={() => {
                    window.open(MEDIA_KIT_LINK, '_blank');
                  }}
                />
              </Menu>
            }
            isOpen={isPopoverOpen}
            positions={['bottom']}
            onClickOutside={_toggleLogoPopover}>
            <Logo $large={large} onContextMenu={_handleRightClick}>
              <LinkWithQuery to="/">
                <HexLogo />
              </LinkWithQuery>
            </Logo>
          </Popover>
        ) : (
          <Logo $large={large}>
            <LinkWithQuery to="/">
              <HexLogo />
            </LinkWithQuery>
          </Logo>
        )}
      </>
    );
  }
);
